import { Enums } from "../../../thor.enums";
import { onlineT } from "../../../typings/online";

interface ItemBids {
    count: number;
    bids: onlineT.LastBid[];
}

export class ItemBidsDialogController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$translate",
        "onlineItemService",
        "onlinePriceService",
        "toaster"
    ];

    // binded
    public itemId: number;
    public saleCurrency: Enums.Currency;

    public itemBids = <ItemBids>{ count: 0, bids: [] };
    public loading: boolean = true;

    public hasBidsWithSameAmount = false;
    public hasBidAndOasWithSameAmount = false;

    private $t;

    constructor(
        private $log: ng.ILogService,
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        $translate: ng.translate.ITranslateService,
        private onlineItemService: any,
        protected onlinePriceService,
        private toaster: any
    ) {
        this.$t = $translate.instant;
    }

    public $onInit() {
        this.onlineItemService
            .getBids(this.itemId)
            .then((bids: onlineT.LastBid[]) => {
                this.itemBids = { count: bids.length, bids };
                this.checkBidsWithSameAmount();
            })
            .catch((error: any) => {
                this.$log.error(`Unable to fetch item ${this.itemId} bids: `, error);
                this.$mdDialog.hide();
                this.toaster.show(this.$t("une_erreur_est_survenue_recuperation_des_encheres_impossible"));
            })
            .finally(() => (this.loading = false));
    }

    public cancelDialog() {
        this.$mdDialog.cancel();
    }

    private checkBidsWithSameAmount(): void {
        this.hasBidsWithSameAmount = this.itemBids.bids.some((bid, i, bids) => {
            const nextBid = bids[i + 1];

            if (!bid || !nextBid) {
                return false;
            }
            return bid.amount === nextBid.amount;
        });

        if (!this.hasBidsWithSameAmount) {
            return;
        }

        this.hasBidAndOasWithSameAmount = this.itemBids.bids.some((bid, i, bids) => {
            const nextBid = bids[i + 1];

            if (!bid || !nextBid) {
                return false;
            }
            return bid.amount === nextBid.amount && bid.is_from_order !== nextBid.is_from_order;
        });
    }
}
